import { render, staticRenderFns } from "./TemplateVariousTags.vue?vue&type=template&id=1463d0a4&"
import script from "./TemplateVariousTags.vue?vue&type=script&lang=ts&"
export * from "./TemplateVariousTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports